/**
 * @author: dwi.setiyadi@gmail.com
 */

import React from "react";

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  {
    path: "/roles/menu",
    exact: true,
    name: "Menu",
    component: React.lazy(() => import("./views/Menu")),
  },
  {
    path: "/roles/mapping",
    exact: true,
    name: "Role Mapping",
    component: React.lazy(() => import("./views/RoleMapping")),
  },
  {
    path: "/roles/audit-log",
    exact: true,
    name: "Audit Log",
    component: React.lazy(() => import("./views/AuditLog")),
  },
];

export default routes;
